import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import ReactPaginate from "react-paginate";
import ReactTooltip from "react-tooltip";
import Switch from "react-switch";
import LocationSelect from "../general/LocationSelect.js";
import Loading from "../general/Loading.js";
import Search from "../general/Search.js";
import GeneralTd from "../table-componets/GeneralTd.js";
import LinkTd from "../table-componets/LinkTd.js";
import ButtonTd from "../table-componets/ButtonTd.js";
import Statuses from "./Statuses";

class GroupLessons extends React.Component {
  state = {
    selectedLocationId: "",
    searchText: "",
    status: "current",
    page: 1,
    perPage: 25,
    totalPages: 1,
    orderBy: "start_date,start_time",
    orderDir: "ASC",
    groupLessons: [],
    loading: true,
  };

  componentDidMount() {
    this.buildData();
  }

  buildData() {
    var that = this;
    var params = {
      page: this.state.page,
      status: this.state.status,
      per_page: this.state.perPage,
      order_by: this.state.orderBy,
      order_dir: this.state.orderDir,
    };

    if (this.state.selectedLocationId) {
      params["location_id"] = this.state.selectedLocationId;
    }

    if (this.state.searchText) {
      params["search"] = this.state.searchText;
    }
    that.setState({ loading: true });

    axios({
      method: "get",
      url: "/group_lessons.json",
      params: params,
      responseType: "json",
    })
      .then(function (response) {
        that.setState({
          loading: false,
          error: false,
          groupLessons: response.data,
          totalPages: Math.ceil(response.headers.total / that.state.perPage),
        });
      })
      .catch(() => {
        that.setState({
          loading: false,
          error: true,
          groupLessons: [],
        });
      });
  }

  newStatus = ({ target: { value } }) => {
    this.setState(
      { status: value, page: 1, orderDir: value == "completed" ? "DESC" : "ASC" },
      () => {
        this.buildData();
      }
    );
  };

  newLocation(newLocation) {
    this.setState(
      { loading: true, selectedLocationId: newLocation, page: 1 },
      () => {
        this.buildData();
      }
    );
  }

  newSearch(newSearch) {
    this.setState({ searchText: newSearch, page: 1 }, () => {
      this.buildData();
    });
  }

  openModal() {
    $("#filtersModal").modal("show");
  }

  viewResults() {
    $("#filtersModal").modal("hide");
    setTimeout(
      function () {
        this.buildData();
      }.bind(this),
      100
    );
  }

  clearFilters() {
    var that = this;

    that.setState({});

    $("#filtersModal").modal("hide");

    setTimeout(
      function () {
        that.buildData();
      }.bind(that),
      100
    );
  }

  sortData(orderBy) {
    if (orderBy == this.state.orderBy) {
      if (this.state.orderDir == "DESC") {
        this.setState({ orderDir: "ASC" });
      } else {
        this.setState({ orderDir: "DESC" });
      }
    } else {
      this.setState({ orderBy: orderBy });
      this.setState({ orderDir: "DESC" });
    }

    setTimeout(
      function () {
        this.buildData();
      }.bind(this),
      50
    );
  }

  changePage(increment) {
    var page = this.state.page + increment;
    this.setState({ page: page });
    setTimeout(
      function () {
        this.buildData();
      }.bind(this),
      50
    );
  }

  goPage = (data) => {
    this.setState({ page: data.selected + 1 }, () => {
      this.buildData();
    });
  };

  toggleColumn = (e, column) => {
    var that = this;
    that.setState({ [column]: e });
  };

  exportData() {
    var params = {};

    params["status"] = this.state.status
    if (this.state.selectedLocationId) {
      params["location_id"] = this.state.selectedLocationId;
    }

    axios
      .get("/schedule_group_lessons_export", {
        params: params,
      })
      .then(function (response) {
        toastr.info(
          "Your Excel Export will be generated shortly, an email with a link will be sent and the file will be available in your My Downloads."
        );
      })
      .catch(function (error) {
        toastr.error("Unable to export lessons at this time");
      });
  }

  renderPagination() {
    return (
      <ReactPaginate
        forcePage={this.state.page - 1}
        previousLabel={"Previous"}
        nextLabel={"Next"}
        breakLabel={"..."}
        breakClassName={"break-me"}
        pageCount={this.state.totalPages}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={this.goPage}
        containerClassName={"pagination"}
        activeClassName={"active"}
      />
    );
  }

  renderBody() {
    var that = this;
    var groupLessons = [];

    _.forEach(this.state.groupLessons, function (groupLesson, index) {
      var instructorsLength = groupLesson.group_lesson_instructors.length;
      groupLessons.push(
        <tr key={index}>
          <GeneralTd
            fieldClassName="hidden-xs hidden-sm"
            fieldValue={groupLesson.location.name}
          />
          <GeneralTd fieldValue={groupLesson.group_lesson_program.name} />
          <GeneralTd
            fieldClassName="hidden-xs hidden-sm"
            fieldValue={groupLesson.group_lesson_level.name}
          />

          <td className="visible-xs visible-sm">
            {groupLesson.abbreviated_days}
            <br />
            {groupLesson.times}
          </td>

          <GeneralTd
            fieldClassName="hidden-xs hidden-sm"
            fieldValue={groupLesson.abbreviated_days}
          />

          <td>
            {groupLesson.group_lesson_instructors.length != 0 ? (
              groupLesson.group_lesson_instructors.map((instructor, index) => (
                <a
                  className="styled-link pointer-hand"
                  href={"/users/" + instructor.user.id}
                  key={instructor.id}
                >
                  {instructor.user.first_name + " " + instructor.user.last_name}
                  {index + 1 !== instructorsLength ? "," : ""}
                  <br />
                </a>
              ))
            ) : (
              <span>-</span>
            )}
          </td>

          <td className="hidden-xs hidden-sm">
            {groupLesson.coordinator_id && groupLesson.coordinator ? (
              <a
                className="styled-link pointer-hand"
                href={"/users/" + groupLesson.coordinator_id}
              >
                {groupLesson.coordinator.last_name},
                <br />
                {groupLesson.coordinator.first_name}
              </a>
            ) : (
              <span>-</span>
            )}
          </td>

          <GeneralTd
            fieldClassName="hidden-xs hidden-sm"
            fieldValue={groupLesson.member_count}
          />
          <GeneralTd
            fieldClassName="hidden-xs hidden-sm"
            fieldValue={groupLesson.session}
          />
          <GeneralTd
            fieldClassName="hidden-xs hidden-sm"
            fieldValue={groupLesson.times}
          />
          <GeneralTd
            fieldClassName="hidden-xs hidden-sm"
            fieldValue={groupLesson.class_code}
          />
          <GeneralTd fieldValue=" " noteValue={groupLesson.notes} />
          <ButtonTd
            fieldName="VIEW"
            fieldURL={"/group_lessons/" + groupLesson.id}
          />
        </tr>
      );
    });
    return <tbody>{groupLessons}</tbody>;
  }

  render() {
    var that = this;

    return (
      <div>
        <h1>Lessons</h1>
        <div className="row">
          <LocationSelect
            locationId={this.props.locationId}
            locations={this.props.locations}
            selectClassName="col-md-3 col-xs-12"
            newLocationCallback={(newLocation) => this.newLocation(newLocation)}
          />
          <Statuses value={this.state.status} onChange={this.newStatus} statusTitle="Select Status"/>
          <Search
            newSearchCallback={(newSearch) => this.newSearch(newSearch)}
          />

          <div className="col-xs-6 col-sm-6 col-md-4 pull-right">
            <div className="pull-right">
              {this.props.currentUserAdmin && (<a
                className="btn btn-pink btn-raised btn-long margin-right-five"
                href={"/group_lessons/new?location_id=" + that.state.selectedLocationId}
              >
                ADD
              </a>)}
              <button       
                className="btn btn-indigo btn-raised btn-long margin-right-five hidden-xs"
                onClick={() => that.exportData()}
              >
                EXPORT
              </button>
              <br className="visible-xs visible-sm" />
            </div>
          </div>
        </div>
        <br />
        {that.state.groupLessons.length && !this.state.loading ? (
          <div>
            <table className="table table-clean table-white">
              <thead>
                <tr>
                  <th className="hidden-xs hidden-sm">
                    <a
                      onClick={(e) => { e.preventDefault(); this.sortData("locations-name"); }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          this.sortData("locations-name");
                        }
                      }}
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by Location"
                      tabIndex="0"
                    >
                      Location
                    </a>
                  </th>
                  
                  <th>
                    <a
                      onClick={(e) => { e.preventDefault(); this.sortData("group_lesson_programs-name"); }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          this.sortData("group_lesson_programs-name");
                        }
                      }}
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by Program"
                      tabIndex="0"
                    >
                      Program
                    </a>
                  </th>
                  
                  <th className="hidden-xs hidden-sm">Level</th>
                  <th className="hidden-xs hidden-sm">Days</th>
                  <th className="visible-xs visible-sm">Schedule</th>
                  
                  <th>
                    <a
                      onClick={(e) => { e.preventDefault(); this.sortData("users-last_name"); }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          this.sortData("users-last_name");
                        }
                      }}
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by Instructor(s)"
                      tabIndex="0"
                    >
                      Instructor(s)
                    </a>
                  </th>
                  
                  <th className="hidden-xs hidden-sm">Coordinator</th>
                  <th className="hidden-xs hidden-sm">Members</th>
                  
                  <th className="hidden-xs hidden-sm">
                    <a
                      onClick={(e) => { e.preventDefault(); this.sortData("start_date,start_time"); }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          this.sortData("start_date,start_time");
                        }
                      }}
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by Session"
                      tabIndex="0"
                    >
                      Session
                    </a>
                  </th>
                  
                  <th className="hidden-xs hidden-sm">
                    <a
                      onClick={(e) => { e.preventDefault(); this.sortData("start_time"); }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          this.sortData("start_time");
                        }
                      }}
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by Time"
                      tabIndex="0"
                    >
                      Time
                    </a>
                  </th>
                  
                  <th className="hidden-xs hidden-sm">Class Code</th>
                  <th className="hidden-xs hidden-sm">Notes</th>
                  <th />
                </tr>
              </thead>

              {this.renderBody()}
            </table>
            {this.renderPagination()}
          </div>
        ) : (
          <Loading
            loading={this.state.loading}
            noDataMessage="No lessons"
            error={this.state.error}
          />
        )}
        <div id="filtersModal" className="modal fade" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
                <h4 className="modal-title">Filters</h4>
              </div>
              <div className="modal-body" />
              <br />
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-indigo"
                  onClick={() => that.viewResults()}
                >
                  VIEW RESULTS
                </button>
                <button
                  type="button"
                  className="btn btn-grey"
                  onClick={() => that.clearFilters()}
                >
                  CLEAR FILTERS
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

GroupLessons.propTypes = {
  groupLessonLevels: PropTypes.array,
  locations: PropTypes.array,
  currentUserAdmin: PropTypes.bool,
};

export default GroupLessons;

// <div className='col-xs-6 col-sm-6 col-md-2'>
//   <a className='btn btn-grey btn-raised pull-right'
//      onClick={()=>this.openModal()}>
//   FILTERING OPTIONS
//   </a>
//   <br className='visible-xs visible-sm' />
//   <br className='visible-xs visible-sm' />
// </div>
